import { render, staticRenderFns } from "./StatusDropdown.vue?vue&type=template&id=4a64d08e&scoped=true"
import script from "./StatusDropdown.vue?vue&type=script&lang=js"
export * from "./StatusDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64d08e",
  null
  
)

export default component.exports